<template>
    <div class="container feedback template-bg-gray my-position-relative">
        <md-card class="request-status loop_container bg-transparent update-request-form-common">
            <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                <div class="card form-wrapper text-center p-20">
                    <h4 class="template-custom-title" v-if="!message.length">checking...</h4>
                    <h4 class="template-custom-title" else>{{message}}</h4>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import API from "../services/API";
export default {
    name: 'RequestClose',
    props: ['ask_id'],
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (!this.$route.query.askid) {
            this.$router.push('/');
        }
    },
    async created() {
        await this.api.get(`asks/${this.$route.query.askid}`).then(async ask => {
            if (ask.data && ask.data.status !== '(7) Closed') {
                let body = {
                    askId: this.$route.query.askid
                }
                if (this.$route.query.memberid) {
                    body.memberid = this.$route.query.memberid
                }
                await this.api.post(`asks/request-close`, body).then(response => {
                    this.message = 'Thank you for closing the request.';
                });
            } else {
                this.message = 'Thank you';
            }
        }).catch(err => {
            console.log('err', err);
            this.$toast.error('Something went wrong');
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestClose.vue